/**
 * 地域判定のための設定
 * 各エリアのキーワードを配列で定義し、マッチした場合のエリア名を返す
 */
export const AREA_DETECTION_CONFIG = {
    fukuoka: {
        keywords: ['福岡市', '北九州市', '筑後地区', '筑豊地区', '佐賀'],
        areaName: 'fukuoka'
    },
    kansai: {
        keywords: ['大阪市', '大阪市外', '京都府', '奈良県', '兵庫県', '和歌山県'],
        areaName: 'kansai'
    },
    nagoya: {
        keywords: ['名古屋市', '名古屋市外', '岐阜県', '三重県'],
        areaName: 'nagoya'
    },
    sendai: {
        keywords: ['仙台市', '仙台市外', '岩手県', '秋田県', '山形県', '福島県'],
        areaName: 'sendai'
    },
    sapporo: {
        keywords: ['道央', '道東', '道北', '道南'],
        areaName: 'sapporo'
    },
    shizuoka: {
        keywords: ['中部', '東部', '西部'],
        areaName: 'shizuoka'
    },
    northern_kanto: {
        keywords: ['群馬県', '茨城県', '栃木県'],
        areaName: 'northern_kanto'
    }
}

/**
 * 地域判定ロジック
 * @param {string[]} areaFilters - エリアフィルターの配列
 * @returns {string} 判定されたエリア名（デフォルト: 'kanto'）
 */
export const detectArea = (areaFilters) => {
    if (!areaFilters || !Array.isArray(areaFilters)) {
        return 'kanto'
    }

    // 各エリアのキーワードをチェック
    for (const [areaKey, config] of Object.entries(AREA_DETECTION_CONFIG)) {
        const hasMatchingKeyword = config.keywords.some(keyword =>
            areaFilters.some(filter => filter.includes(keyword))
        )
        
        if (hasMatchingKeyword) {
            return config.areaName
        }
    }

    // マッチするエリアがない場合はデフォルトの関東エリアを返す
    return 'kanto'
}
